




















import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';

import GenericCard from '@/components/cards/GenericCard.vue';
import { ModalSize } from '@/components/zen_modal/types';

export default Vue.extend({
  name: 'ConfigDeleteCard',
  components: {
    GenericCard,
  },
  data() {
    return {
      deleting: false,
    };
  },
  computed: {
    ...mapGetters({
      selectedConfiguration: 'export/selectedConfiguration',
    }),
    configurationTitle(): string {
      return this.selectedConfiguration ? this.selectedConfiguration.title : '';
    },
  },
  created() {
    this.changeModalSize(ModalSize.Small);
  },
  methods: {
    ...mapActions({
      cancelModal: 'modals/cancel',
      changeModalSize: 'modals/changeSize',
      confirmModal: 'modals/confirm',
      deleteConfig: 'export/deleteConfig',
      loadConfigList: 'export/loadConfigList',
      showAlert: 'alerts/show',
    }),
    async confirmDeletion() {
      try {
        this.deleting = true;
        await this.deleteConfig(this.selectedConfiguration.id);
        this.showAlert({
          type: 'success',
          message: 'Report configuration deleted successfully.',
        });
        await this.loadConfigList();
        this.confirmModal();
      } catch (error) {
        this.showAlert({
          type: 'error',
          message: 'Oops, something went wrong.',
        });
      } finally {
        this.deleting = false;
      }
    },
  },
});
